
import Item from './item.vue'

export default {
  components: {
    Item,
  },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [],
      current: null,
      previous: null,
      ctx: null,
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    updateCurrent(id) {
      this.previous = this.current
      this.current = id
    },

    init() {
      const gridContainer = this.$refs.grid
      const gridItemArray = [...gridContainer.querySelectorAll('.grid__item')]
      gridItemArray.forEach((item) => this.items.push(item))

      this.ctx = this.$gsap.context(() => {})
    },

    resetGrid() {
      const item = this.$el.querySelector(`[data-index="${this.current}"]`)

      if (!item) return

      const overlay = item?.querySelector('.grid__item-overlay')
      const textContainer = item?.querySelector('.grid__item-text-container')
      const img = item?.querySelector('.grid__item-img')

      const ctx = this.ctx
      this.ctx.add((self) => {
        // animate
        this.tl = this.$gsap
          .timeline({
            defaults: {
              duration: Number(this.blok.durationMobile) || 0.3,
              ease: this.blok.ease || 'power4',
            },
            onUpdate() {
              if (this.progress() >= 0.3) {
                ctx.revert()
              }
            },
          })
          .addLabel('start', 0)
          .addLabel('end', Number(this.blok.durationMobile) || 0.3)
          .set(
            item,
            {
              zIndex: 1,
            },
            'end'
          )

        this.tl
          .to(
            item,
            {
              scale: 1,
              x: 0,
              y: 0,
              rotation: 0,
            },
            'start'
          )
          .to(
            img,
            {
              scale: 1.2,
              duration: 0.3,
            },
            'start'
          )
          .to(
            [overlay, textContainer],
            {
              opacity: 0,
              duration: 0.3,
            },
            'start'
          )

        // reset all items - desktop
        // disable on mobile for performance
        if (this.$matchMedia('sm')) {
          this.items.forEach((otherItem) => {
            const { x, y } = { x: 0, y: 0 }

            const delay = 0 // this.expanded === -1 ? 0 : map(getDistance(otherItem, item), 0, 1500, 0, 0.2);

            this.tl
              // .set(
              //   otherItem,
              //   {
              //     zIndex: 1,
              //     delay,
              //   },
              //   'end'
              // )
              .to(
                otherItem,
                {
                  x,
                  y,
                  rotation: 0,
                  delay,
                },
                'start'
              )
          })
        }
      })

      this.current = null
      this.previous = null
    },
  },
}
